'use client';

import { c as _c } from "react/compiler-runtime";
import { HeroUIProvider } from "@heroui/react";
import { type Config, cookieToInitialState, type State } from "@wagmi/core";
import { useRouter } from "next/navigation";
import { wagmiAdapter } from "@/config/index";
import Web3Provider from "../context";
import Toast from "@/components/Toast";
// import ServiceWorkerRegister from "@/components/RegisterServiceWorker";

export function Providers(t0) {
  const $ = _c(9);
  const {
    children,
    cookies
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== cookies) {
    t1 = cookieToInitialState(wagmiAdapter.wagmiConfig as Config, cookies);
    $[0] = cookies;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialState = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Toast />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== initialState) {
    t3 = <Web3Provider initialState={initialState}>{t2}{children}</Web3Provider>;
    $[3] = children;
    $[4] = initialState;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== router.push || $[7] !== t3) {
    t4 = <HeroUIProvider navigate={router.push}>{t3}</HeroUIProvider>;
    $[6] = router.push;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}